import * as React from 'react';

import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';

import { RequiredPick } from '@/app/@types/utilities';
import { cn } from '@/app/utils/cn';

import { buttonVariants } from './styles';

interface ButtonProps
  extends RequiredPick<React.ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label'>,
    Omit<VariantProps<typeof buttonVariants>, 'disabled'> {
  asChild?: boolean;
  'data-testid': string;
  ref?: React.Ref<HTMLButtonElement>;
}

const Button = ({
  ref,
  size,
  variant,
  disabled,
  children,
  className,
  critical,
  asChild = false,
  ...props
}: ButtonProps) => {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      tabIndex={0}
      role="button"
      disabled={disabled}
      aria-disabled={disabled}
      className={cn(buttonVariants({ variant, size, className, disabled, critical }))}
      ref={ref}
      {...props}
    >
      {children}
    </Comp>
  );
};

Button.displayName = 'Button';

export { Button, type ButtonProps };
